import axios from 'axios';

const ICONS = {
  overview: 'chart-line',
  scorecard: 'user-check',
  attribution: 'users',
  coding: 'file-medical',
  quality: 'clipboard-list-check',
  utilization: 'hospital',
  explorer: 'magnifying-glass',
  patients: 'user',
};

export async function fetchPortalTabs() {
  const { data } = await axios.get('/api/impact_analytics/agent-pages/external/');
  return data.tabs || [];
}

export function portalNavItems(tabs) {
  return tabs.map((tab) => ({ id: tab.key, label: tab.label, icon: ICONS[tab.key] || 'file-lines' }));
}
